<template>
  <div class="view-container">
    <div class="recipe-list-search-bar">
      <input
        placeholder="Zoeken..."
        v-model="searchQuery"
        class="recipe-list-search-bar__input"
      />
      <div class="recipe-list-search-bar__clear">
        <img
          v-show="searchQuery"
          @click="searchQuery = ''"
          src="../assets/close.svg"
          height="16px"
          width="16px"
        />
      </div>
    </div>
    <router-link to="/add-recipe">Toevoegen</router-link>
    <div class="recipe-list">
      <router-link
        tag="div"
        v-for="recipe in filteredRecipes"
        :key="recipe.id"
        class="recipe-list__item"
        :to="`/recipe/${recipe.id}`"
        >{{ recipe.name }}</router-link
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      searchQuery: "",
    };
  },
  computed: {
    ...mapGetters(["recipes"]),
    filteredRecipes() {
      if (this.searchQuery) {
        const regex = new RegExp(this.searchQuery, "i");
        return this.recipes.filter((recipe) => recipe.name.match(regex));
      } else {
        return this.recipes;
      }
    },
  },
};
</script>
